import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function FailedSolutions() {
  return <section className="bg-slate-800 text-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-35">
      <div className="max-w-4xl mx-auto" data-id="element-36">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-37">
          Por qué lo que has intentado{' '}
          <span className="text-amber-500" data-id="element-38">no funciona</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-39">
          <div className="bg-slate-900/50 p-6 rounded-2xl border border-slate-700 flex items-start" data-id="element-40">
            <XCircleIcon className="w-6 h-6 text-red-400 mr-4 flex-shrink-0 mt-1" data-id="element-41" />
            <p className="text-slate-300 text-lg" data-id="element-42">
              <strong className="text-white block mb-1" data-id="element-43">
                Apps de registro de gastos
              </strong>
              No funcionan porque anotan lo que ya perdiste. Son un espejo
              retrovisor, no un volante.
            </p>
          </div>

          <div className="bg-slate-900/50 p-6 rounded-2xl border border-slate-700 flex items-start" data-id="element-44">
            <XCircleIcon className="w-6 h-6 text-red-400 mr-4 flex-shrink-0 mt-1" data-id="element-45" />
            <p className="text-slate-300 text-lg" data-id="element-46">
              <strong className="text-white block mb-1" data-id="element-47">
                Presupuestos rígidos
              </strong>
              Fallan porque no contemplan los imprevistos reales de nuestra
              economía y la vida diaria.
            </p>
          </div>

          <div className="bg-slate-900/50 p-6 rounded-2xl border border-slate-700 flex items-start" data-id="element-48">
            <XCircleIcon className="w-6 h-6 text-red-400 mr-4 flex-shrink-0 mt-1" data-id="element-49" />
            <p className="text-slate-300 text-lg" data-id="element-50">
              <strong className="text-white block mb-1" data-id="element-51">
                "Ahorrar lo que sobre"
              </strong>
              Es una mentira; nunca sobra nada si no tienes un plan estructurado
              desde el día uno.
            </p>
          </div>

          <div className="bg-slate-900/50 p-6 rounded-2xl border border-slate-700 flex items-start" data-id="element-52">
            <XCircleIcon className="w-6 h-6 text-red-400 mr-4 flex-shrink-0 mt-1" data-id="element-53" />
            <p className="text-slate-300 text-lg" data-id="element-54">
              <strong className="text-white block mb-1" data-id="element-55">
                Una sola cuenta bancaria
              </strong>
              El desorden de tener todo junto hace imposible saber qué puedes
              gastar realmente hoy.
            </p>
          </div>
        </div>
      </div>
    </section>;
}